import requestFunctions from "../../functions/requestFunctions";
import strFunctions from "../../functions/strFunctions";

export const state = {
  FINANCE_ITEM: {},
  FINANCE_LIST: [],
  FINANCE_TABLE_DATA: [],
  FINANCE_TOTAL_ROWS: 0
}

export const getters = {
  GET_FINANCE_ITEM: (state) => {
    return state.FINANCE_ITEM;
  },
  GET_FINANCE_LIST: (state) => {
    return state.FINANCE_LIST;
  },
  GET_FINANCE_TABLE_DATA: (state) => {
    return state.FINANCE_TABLE_DATA;
  },
  GET_FINANCE_TOTAL_ROWS: (state) => {
    return state.FINANCE_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_FINANCE_ITEM(state, item) {
    state.FINANCE_ITEM = item;
  },

  UPDATE_FINANCE_LIST(state, list) {

    state.FINANCE_LIST = list.data;
    state.FINANCE_TABLE_DATA = [];

    state.FINANCE_TOTAL_ROWS = list.total;
    list = list.data;

    if(list.length > 0) {
      list.forEach(el => {

        let status;

        if(el.status === 'wait'){
          status = 'Ожидается оплата'
        }
        if(el.status === 'blocked'){
          status = 'Заблокирована'
        }
        if(el.status === 'cancelled'){
          status = 'Отменена'
        }
        if(el.status === 'success'){
          status = 'Успешно'
        }
        if(el.status === 'error'){
          status = 'Ошибка'
        }
        if(el.status === 'payment'){
          status = 'Оплачивается'
        }

        let account_from = '';
        account_from = strFunctions.strConcat(', ', account_from, el.account_from_number ? el.account_from_number : '');
        account_from = strFunctions.strConcat(', ', account_from, el.user_from_phone ? el.user_from_phone : '');
        account_from = strFunctions.strConcat(', ', account_from, el.profile_from_fullname ? el.profile_from_fullname : '');
        account_from = strFunctions.strConcat(', ', account_from, el.company_from_name ? el.company_from_name : '');
        account_from = strFunctions.strConcat(', ', account_from, el.project_from_name ? el.project_from_name : '');

        let account_to   = '';
        account_to = strFunctions.strConcat(', ', account_to, el.account_to_number ? el.account_to_number : '');
        account_to = strFunctions.strConcat(', ', account_to, el.user_to_phone ? el.user_to_phone : '');
        account_to = strFunctions.strConcat(', ', account_to, el.profile_to_fullname ? el.profile_to_fullname : '');
        account_to = strFunctions.strConcat(', ', account_to, el.company_to_name ? el.company_to_name : '');
        account_to = strFunctions.strConcat(', ', account_to, el.project_to_name ? el.project_to_name : '');

        state.FINANCE_TABLE_DATA.push({
          'id': el.id,
          'uuid': el.uuid,
          'created_at': el.created_at,
          'finance_type_name': el.finance_type_name,
          'account_from_number': account_from,
          'currency_from_code': el.currency_from_code,
          'currency_to_code': el.currency_to_code,
          'account_to_number': account_to,
          'pay_method_name': el.pay_method_name,
          'pay_gate_name': el.pay_gate_name,
          'recipient_details': el.recipient_details,
          'tariff_name': el.tariff_name,
          'comments': el.comments,
          'sum': el.sum,
          'status': status,
          'updated_at': el.updated_at,
        });

      });
    }
  }
}


export const actions = {

  async FETCH_FINANCE_ITEM({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/finance/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_FINANCE_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_FINANCE_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/finance';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_FINANCE_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_FINANCE_CREATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/finance';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_FINANCE_UPDATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/finance/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_FINANCE_DELETE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/finance/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}